// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/servicos/bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* import bg from ../../assets/servicos/bg.svg; */


.customModal {
  max-width: 90% !important;
  border-radius: 5px;
  width: 100%;
  color: #af8559;
}
.cards-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: baseline;
  gap: 2rem 2rem;
  margin-top: 2rem;
}

.main-modal-container {
  min-width: 465px;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  justify-content: center;
  align-items: center;
}

.first-modal-content-container {
  margin-right: 5%;
  width: 90%;
  background-color: #efefef;
  border-radius: 5px;
  min-width: 326px;
  display: flex;
  color: #af8559;
  min-height: 50dvh;
  margin: 9dvh 5dvh;
}

.first-side-title-container {
  display: flex;
  width: 6%;
  justify-content: center;
  align-items: center;
  min-width: 45px;
}

.first-content-list {
  display: flex;
  flex-direction: column;
  width: 50%;
  justify-content: center;
}

.delivery-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6dvh;
}

.notes-list {
  flex-direction: column;
  width: 50%;
  /* position: absolute; */
  margin-left: 20vw;
  color: #af8559;
  max-height: 360px;
  min-width: 340px;
}

.notes-item {
  padding: .5rem 1rem;
  padding-left: 0;
  margin-left: 30px;
}

.side-title {
  color: #af8559;
  rotate: -90deg;
  position: absolute;
  white-space: nowrap;
  font-size: calc(15px + 3vh);
}

.divider {
  border-left: 1px dashed;
  height: 80%;
  align-self: center;
  width: 0
}

@media (max-width: 800px)
{
  .divider {
    display: none;
  }
  .first-modal-content-container {
    flex-direction: column;
  }
  .first-content-list {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Services/style.css"],"names":[],"mappings":"AAAA,iDAAiD;;;AAGjD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yDAAmD;EACnD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* import bg from ../../assets/servicos/bg.svg; */\n\n\n.customModal {\n  max-width: 90% !important;\n  border-radius: 5px;\n  width: 100%;\n  color: #af8559;\n}\n.cards-container{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: 2rem 2rem;\n  margin-top: 2rem;\n}\n\n.main-modal-container {\n  min-width: 465px;\n  width: 100%;\n  background-image: url(../../assets/servicos/bg.svg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.first-modal-content-container {\n  margin-right: 5%;\n  width: 90%;\n  background-color: #efefef;\n  border-radius: 5px;\n  min-width: 326px;\n  display: flex;\n  color: #af8559;\n  min-height: 50dvh;\n  margin: 9dvh 5dvh;\n}\n\n.first-side-title-container {\n  display: flex;\n  width: 6%;\n  justify-content: center;\n  align-items: center;\n  min-width: 45px;\n}\n\n.first-content-list {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  justify-content: center;\n}\n\n.delivery-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 6dvh;\n}\n\n.notes-list {\n  flex-direction: column;\n  width: 50%;\n  /* position: absolute; */\n  margin-left: 20vw;\n  color: #af8559;\n  max-height: 360px;\n  min-width: 340px;\n}\n\n.notes-item {\n  padding: .5rem 1rem;\n  padding-left: 0;\n  margin-left: 30px;\n}\n\n.side-title {\n  color: #af8559;\n  rotate: -90deg;\n  position: absolute;\n  white-space: nowrap;\n  font-size: calc(15px + 3vh);\n}\n\n.divider {\n  border-left: 1px dashed;\n  height: 80%;\n  align-self: center;\n  width: 0\n}\n\n@media (max-width: 800px)\n{\n  .divider {\n    display: none;\n  }\n  .first-modal-content-container {\n    flex-direction: column;\n  }\n  .first-content-list {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
